import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login/Login";
import Temp from "./pages/Template/Template";
import Shop from "./pages/Shop/Shop";
import ClientsShop from "./pages/Shop/Clients/Clients";
import Category from "./pages/Shop/Clients/zokir.js";
import Inner from "./pages/Shop/Clients/Inner/Inner";
import DataBase from "./pages/Shop/Database/Database";
import Base from "./pages/Shop/Base/Base";
import Jizzax from "./pages/Shop/Jizzax/Jizzax";
import Print from "./pages/Print/Print.jsx";
import Print2 from "./pages/Print/Print2.jsx";
import PrintCloud from "./pages/Print/Print_cloud.jsx";
import InnerShop from "./pages/Shop/InnerShop/Inner";
import Seller from "./pages/Shop/Seller/Seller.jsx";
import History from "./pages/Shop/History/Cloud.jsx";
import Cloud from "./pages/Shop/Cloud/Cloud";
import InnerSeller from "./pages/Shop/Seller/InnerSeller/InnerSeller.jsx";
import Archive from "./pages/Shop/Archive/Archive.jsx";
import ArchiveInner from "./pages/Shop/Archive/Inner/Inner.jsx";
import Draft from "./pages/Shop/Draft/Index.jsx";
import Management from "./pages/Shop/Management/Index.jsx";
import Divison from "./pages/Shop/Divison/Diviison.jsx";
import InnerDivison from "./pages/Shop/Divison/Inner/Inner.jsx";
import PrintDivsion from "./pages/Print/PrindDivision.jsx";
export default function App() {
    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/dashboard" element={<Temp />} />
            <Route path="/print" element={<Print />} />
            <Route path="/print2" element={<Print2 />} />
            <Route path="/print_cloud" element={<PrintCloud />} />
            <Route path="/printDivision" element={<PrintDivsion />} />
            <Route path="/clients" element={<Temp />} />
            <Route path="/clients/:id" element={<Temp />} />
            <Route path="/workers" element={<Temp />} />
            <Route path="/money" element={<Temp />} />
            <Route path="/gold" element={<Temp />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/shop/clients" element={<ClientsShop />} />
            <Route path="/shop/divison" element={<Divison />} />
            <Route path="/shop/divison/:id" element={<InnerDivison />} />
            <Route path="/shop/sellers" element={<Seller />} />
            <Route path="/shop/sellers/:id" element={<InnerSeller />} />
            <Route path="/shop/clients/:id" element={<Inner />} />
            <Route path="/shop/clients/category/:id" element={<Category />} />
            <Route path="/shop/archive" element={<Archive />} />
            <Route path="/shop/archive/:id" element={<ArchiveInner />} />
            <Route path="/room/:id" element={<InnerShop />} />
            <Route path="/shop/database" element={<DataBase />} />
            <Route path="/shop/base" element={<Base />} />
            <Route path="/shop/cloud" element={<Cloud />} />
            <Route path="/shop/history" element={<History />} />
            <Route path="/shop/jizzax" element={<Jizzax />} />
            <Route path="/shop/draft" element={<Draft />} />
            <Route path="/shop/manage" element={<Management />} />
        </Routes>
    );
}
